export default __webpack_public_path__ + "static/media/cv.02b00606.png";